<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 pt-2">
        <span [innerHTML]="labelHtml | placeholderHighlight: editor"></span>
      </div>
      <div class="col-2 d-flex flex-row justify-content-end align-items-center suggestion-anchor">
        <mat-checkbox-with-roles
          [labelPosition]="'before'"
          [checked]="checked"
          [disabled]="disabled"
          (change)="checkboxChanged($event)"
          color="primary"
          [roleCodes]="roleCodes"
          [warning]="moreInfo"
          [user]="user"
          [date]="date"
        >
        </mat-checkbox-with-roles>
        <mat-icon
          *ngIf="suggested && !checked && !disabled"
          class="suggestion-icon"
          [matTooltip]="suggestionReason || 'ASCC recommends reviewing and signing this task manually.'"
          matTooltipPosition="above"
          >lightbulb</mat-icon
        >
      </div>
    </div>
  </div>
</div>
